import { useState, useEffect } from "react";
import "./InputProgresso.css";

export default function InputProgresso({ xp }) {
  const XP_nivel = 250; 

  const [xpAnimado, setXpAnimado] = useState(0);
  const [nivelAtual, setNivelAtual] = useState(0);
  const [xpMin, setXpMin] = useState(0);
  const [xpMax, setXpMax] = useState(XP_nivel);

  const xpSeguro = Number(xp) || 0;

  useEffect(() => {
    const nivel = Math.floor(xpSeguro / XP_nivel);

    setNivelAtual(nivel);
    setXpMin(nivel * XP_nivel);
    setXpMax((nivel + 1) * XP_nivel);
  }, [xpSeguro]);

  // Animação suave do XP
  useEffect(() => {
    const alvo = xpSeguro;
    let progresso = xpAnimado;

    const duracao = 800;
    const steps = 60;
    const incremento = (alvo - progresso) / steps;
    const intervalo = duracao / steps;

    const animar = setInterval(() => {
      progresso += incremento;

      if (
        (incremento > 0 && progresso >= alvo) ||
        (incremento < 0 && progresso <= alvo)
      ) {
        progresso = alvo;
        clearInterval(animar);
      }

      setXpAnimado(progresso);
    }, intervalo);

    return () => clearInterval(animar);
  }, [xpSeguro]);


  const barraAtual = Math.max(0, xpAnimado - xpMin);
  const barraMax = xpMax - xpMin;

  return (
    <div className="progresso">
      <div className="progresso-feito">
        <div
          className="texto-progresso"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <p>
            Level <span>{nivelAtual}</span>
          </p>

          <p>
            <span className="xp-info">{Math.floor(barraAtual)}</span> / <span>{XP_nivel}</span>
          </p>
        </div>

        <progress
          id="barra-xp"
          value={barraAtual}
          max={barraMax}
          style={{
            width: "100%",
            height: "16px",
            transition: "width 0.3s ease",
          }}
        ></progress>
      </div>
    </div>
  );
}
